import { Type } from "lucide-react";

import { useFontScale } from "../../../lib/useTheme";
import type { FontScale } from "../../../lib/theme";

const ESCALA_OPCIONES: { id: FontScale; label: string; size: string; hint: string }[] = [
  { id: "100", label: "A", size: "16px", hint: "Tamaño normal" },
  { id: "112", label: "A+", size: "18px", hint: "Más legible" },
  { id: "125", label: "A++", size: "20px", hint: "Alta legibilidad" },
];

export function AparienciaTab(): JSX.Element {
  const { scale, setScale } = useFontScale();

  return (
    <div className="space-y-6">
      <div className="rounded-md border border-neutral-200 bg-neutral-50 p-3 text-sm text-neutral-700">
        Esta preferencia se guarda en <strong>este navegador</strong>. No
        afecta a los demás usuarios del comité — cada persona elige su
        propio tamaño de letra.
      </div>

      <section className="rounded-lg border border-neutral-200 bg-white p-5">
        <header className="mb-4 flex items-start gap-3">
          <Type className="h-5 w-5 text-neutral-600 mt-0.5" strokeWidth={1.5} />
          <div>
            <h3 className="text-lg font-semibold text-neutral-900">
              Tamaño de letra
            </h3>
            <p className="text-sm text-neutral-600">
              Aumenta el tamaño base de toda la aplicación. Útil para
              usuarios con baja visión o preferencia de mayor legibilidad.
            </p>
          </div>
        </header>

        <div className="grid gap-3 md:grid-cols-3">
          {ESCALA_OPCIONES.map((opt) => {
            const activa = opt.id === scale;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => setScale(opt.id)}
                aria-pressed={activa}
                className={
                  activa
                    ? "flex items-center justify-between gap-3 rounded-md border-2 border-brand-600 bg-brand-50 px-4 py-3 text-left ring-1 ring-brand-200"
                    : "flex items-center justify-between gap-3 rounded-md border border-neutral-200 bg-white px-4 py-3 text-left hover:border-neutral-300"
                }
              >
                <div className="flex items-center gap-3">
                  <span
                    className={
                      activa
                        ? "font-bold text-brand-700"
                        : "font-bold text-neutral-700"
                    }
                    style={{
                      fontSize:
                        opt.id === "125"
                          ? "1.5rem"
                          : opt.id === "112"
                            ? "1.25rem"
                            : "1rem",
                    }}
                  >
                    {opt.label}
                  </span>
                  <div>
                    <div className="font-semibold text-neutral-900">
                      {opt.size}
                    </div>
                    <div className="text-xs text-neutral-600">
                      {opt.hint}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-xs text-neutral-600">
          El cambio se aplica inmediatamente. Si la nueva escala no se ve
          bien, puedes volver a "A" cuando quieras.
        </p>
      </section>
    </div>
  );
}
